<footer class="tw-bg-[#0b1526] tw-text-white" aria-labelledby="footer-heading">
  <h2 id="footer-heading" class="tw-sr-only">Site footer</h2>
  <div class="tw-container tw-mx-auto tw-px-4 tw-py-12 md:tw-py-14">
    <div class="tw-grid tw-grid-cols-2 md:tw-grid-cols-4 xl:tw-grid-cols-12 tw-gap-8">
      <div class="tw-col-span-2 xl:tw-col-span-3">
        <a routerLink="/" class="tw-inline-flex tw-items-center tw-gap-3 tw-no-underline tw-text-white">
          <img src="logo/safety-knights-logo-light.png" alt="" width="38" height="42" class="tw-h-10 tw-w-auto" />
          <span class="tw-text-lg tw-font-bold tw-uppercase tw-tracking-wide tw-leading-tight">Safety<br />Knights</span>
        </a>
        <p class="tw-text-sm tw-text-white/75 tw-mt-4 tw-mb-5 tw-max-w-[220px]">{{ tagline }}</p>
        <ul class="tw-list-none tw-m-0 tw-p-0 tw-flex tw-gap-2">
          @for (s of social; track s.label) {
          <li>
            <a [href]="s.href" target="_blank" rel="noopener" [attr.aria-label]="s.label"
              class="tw-inline-flex tw-items-center tw-justify-center tw-w-9 tw-h-9 tw-rounded-full tw-bg-white/10 hover:tw-bg-orange-500 tw-text-white tw-transition-colors tw-no-underline">
              <i [class]="s.icon" aria-hidden="true"></i>
            </a>
          </li>
          }
        </ul>
      </div>

      <div class="tw-col-span-2 md:tw-col-span-4 xl:tw-col-span-6 tw-grid tw-grid-cols-2 sm:tw-grid-cols-3 tw-gap-6">
        @for (col of columns; track col.heading) {
        <nav [attr.aria-label]="col.heading">
          <h3 class="tw-text-xs tw-font-bold tw-uppercase tw-tracking-wide tw-text-white tw-mb-3">{{ col.heading }}</h3>
          <ul class="tw-list-none tw-m-0 tw-p-0 tw-flex tw-flex-col tw-gap-2">
            @for (l of col.links; track l.label) {
            <li>
              @if (l.link) {
              <a [routerLink]="l.link" [queryParams]="l.queryParams || null" class="tw-text-sm tw-text-white/80 hover:tw-text-orange-400 tw-no-underline">{{ l.label }}</a>
              } @else {
              <a [href]="l.href" class="tw-text-sm tw-text-white/80 hover:tw-text-orange-400 tw-no-underline">{{ l.label }}</a>
              }
            </li>
            }
          </ul>
        </nav>
        }
      </div>

      <div class="tw-col-span-2 md:tw-col-span-4 xl:tw-col-span-3">
        <div class="tw-rounded-xl tw-border tw-border-orange-500/60 tw-bg-white/5 tw-p-5">
          <h3 class="tw-text-xs tw-font-bold tw-uppercase tw-tracking-wide tw-text-white tw-mb-2">{{ partnerBox.heading }}</h3>
          <p class="tw-text-sm tw-text-white/80 tw-mb-3">{{ partnerBox.body }}</p>
          <a [routerLink]="partnerBox.link" class="tw-text-sm tw-font-semibold tw-text-orange-400 hover:tw-text-orange-300 tw-no-underline">{{ partnerBox.cta }} &rarr;</a>
        </div>
      </div>
    </div>

    <div class="tw-mt-10 tw-pt-6 tw-border-t tw-border-white/10 tw-flex tw-flex-col sm:tw-flex-row tw-justify-between tw-items-start sm:tw-items-center tw-gap-3 tw-text-xs tw-text-white/60">
      <span>&copy; {{ year }} Safety Knights, LLC. All rights reserved.</span>
      <div class="tw-flex tw-flex-wrap tw-items-center tw-gap-x-6 tw-gap-y-2">
        <ul class="tw-list-none tw-m-0 tw-p-0 tw-flex tw-flex-wrap tw-gap-x-6 tw-gap-y-1">
          @for (l of legal; track l.label) {
          <li><a [routerLink]="l.link" class="tw-text-white/70 hover:tw-text-orange-400 tw-no-underline">{{ l.label }}</a></li>
          }
        </ul>
        <div class="tw-inline-flex tw-rounded-full tw-border tw-border-white/15 tw-p-0.5" role="group" aria-label="Colour theme">
          <button type="button" (click)="setTheme(false)" [attr.aria-pressed]="!isDark"
            class="tw-inline-flex tw-items-center tw-gap-1.5 tw-rounded-full tw-px-3 tw-py-1 tw-text-xs tw-font-medium tw-transition-colors"
            [ngClass]="!isDark ? 'tw-bg-white/15 tw-text-white' : 'tw-text-white/60 hover:tw-text-white'">
            <i class="fa-regular fa-sun" aria-hidden="true"></i>Light
          </button>
          <button type="button" (click)="setTheme(true)" [attr.aria-pressed]="isDark"
            class="tw-inline-flex tw-items-center tw-gap-1.5 tw-rounded-full tw-px-3 tw-py-1 tw-text-xs tw-font-medium tw-transition-colors"
            [ngClass]="isDark ? 'tw-bg-white/15 tw-text-white' : 'tw-text-white/60 hover:tw-text-white'">
            <i class="fa-regular fa-moon" aria-hidden="true"></i>Dark
          </button>
        </div>
      </div>
    </div>
  </div>
</footer>
